module.exports = __webpack_public_path__ + "static/media/no-photo-icon.df1b78dc.svg";